import { FileTextIcon, DownloadIcon, ActivityIcon, SmartphoneIcon } from 'lucide-react';

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/bEu6RL2HuCy7oTJ25V3hfR/Pack_digital_de_triatlon_de_larga_distancia.webp';

export const FINAL_CTA_IMAGE =
  'https://cdn.magicpatterns.com/uploads/fAWLayDuFp64KSPbtPLT8j/Coleccion_Triatlon_Sigma_Smart.webp';

export const heroChips = [
  { icon: FileTextIcon, label: 'PDF 100 % numérique et visuel' },
  { icon: DownloadIcon, label: 'Téléchargement immédiat' },
  { icon: ActivityIcon, label: 'Adapté à différents niveaux' },
  { icon: SmartphoneIcon, label: 'Compatible Android et iOS' },
];

export const disciplines = ['Natation', 'Vélo', 'Course à pied', 'Ravitaillement', 'Progression', 'Stratégie de course'];
